import e from "./en/actions.mjs";
import t from "./en/account.mjs";
import n from "./en/adminMcp.mjs";
import r from "./en/auth.mjs";
import i from "./en/booking.mjs";
import a from "./en/channelPartners.mjs";
import o from "./en/chat.mjs";
import s from "./en/common.mjs";
import c from "./en/countries.mjs";
import l from "./en/coupons.mjs";
import u from "./en/creator.mjs";
import d from "./en/csat.mjs";
import f from "./en/dashboard.mjs";
import p from "./en/datetime.mjs";
import m from "./en/developer.mjs";
import h from "./en/ds.mjs";
import g from "./en/enums.mjs";
import _ from "./en/experiences.mjs";
import v from "./en/finance.mjs";
import y from "./en/frontDesk.mjs";
import b from "./en/frontDeskNative.mjs";
import x from "./en/guestIntel.mjs";
import S from "./en/help.mjs";
import C from "./en/hosting.mjs";
import w from "./en/hosts.mjs";
import T from "./en/icalSync.mjs";
import E from "./en/navigation.mjs";
import D from "./en/notifications.mjs";
import O from "./en/onboarding.mjs";
import k from "./en/payments.mjs";
import A from "./en/photos.mjs";
import j from "./en/pricing.mjs";
import M from "./en/properties.mjs";
import N from "./en/rates.mjs";
import P from "./en/reports.mjs";
import F from "./en/room.mjs";
import I from "./en/roomType.mjs";
import L from "./en/ruleBuilder.mjs";
import R from "./en/search.mjs";
import z from "./en/shiftBriefing.mjs";
import B from "./en/services.mjs";
import V from "./en/site.mjs";
import H from "./en/travelGuides.mjs";
import U from "./en/trips.mjs";
import W from "./en/validation.mjs";
import G from "./en/verification.mjs";
import K from "./en/workspace.mjs";
//#region src/locales/resources.ts
var q = "common", J = { ar: () => import("./lazy/ar.mjs") }, Y = { en: {
	actions: e,
	account: t,
	adminMcp: n,
	auth: r,
	booking: i,
	channelPartners: a,
	chat: o,
	common: s,
	countries: c,
	coupons: l,
	creator: u,
	csat: d,
	dashboard: f,
	datetime: p,
	developer: m,
	ds: h,
	enums: g,
	experiences: _,
	finance: v,
	frontDesk: y,
	frontDeskNative: b,
	guestIntel: x,
	help: S,
	hosting: C,
	hosts: w,
	icalSync: T,
	navigation: E,
	notifications: D,
	onboarding: O,
	payments: k,
	photos: A,
	pricing: j,
	properties: M,
	rates: N,
	reports: P,
	room: F,
	roomType: I,
	ruleBuilder: L,
	search: R,
	shiftBriefing: z,
	services: B,
	site: V,
	travelGuides: H,
	trips: U,
	validation: W,
	verification: G,
	workspace: K
} };
//#endregion
export { q as DEFAULT_NAMESPACE, J as LAZY_LOCALE_LOADERS, Y as resources };
